import React, {Component} from "react"
import { TileLayer } from 'react-leaflet'
import MapContainer from './MapContainer';
import ErrorImage from '../ErrorImage';
import POIMarker from './POIMarker';
import TruckMarker from './TruckMarker';
import UserMarker from './UserMarker';
import CombinedButton from './CombinedButton';
import UserCenterButton from './UserCenterButton';
import OpenAppButton from './OpenAppButton';
import {store} from "../../App";
import { connect } from 'react-redux';
import { setHideHeader, setToast } from "../../Redux/OverlayActions";
import SilentCallButton from "./SilentCallButton";
import StatusChip from "./StatusChip";
import NearbyPanel from "./NearbyPanel";
import CallMarker from "./CallMarker";
import { hasLiveGps } from "./truckStatus";

class TrackerView extends Component {
    constructor() {
        super();
        this.state = {
            hasInternet: true,
            hasLocationPermission: false,
            deniedLocationPermission: false,
            userLocation: null,
            pois: [],
            karren: [],
            trackid: "firstDrawUser",
            map: null,
            firstDraw: true,
            lastFocusLatitude: 0,
            lastFocusLongitude: 0,
            // New loading/error states
            isLoading: true,
            loadError: null,
            lastSuccessfulFetch: null,
            consecutiveErrors: 0,

        };

        this.setUdid = this.setUdid.bind(this);
        this.checkIframeMode = this.checkIframeMode.bind(this);
        // this.checkServerHeartbeat = this.checkServerHeartbeat.bind(this);
        this.getPOIdata = this.getPOIdata.bind(this);
        this.getMapdata = this.getMapdata.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMapClick = this.handleMapClick.bind(this);
        this.setMap = this.setMap.bind(this);
        this.moveMap = this.moveMap.bind(this);
        this.checkLocationPermission = this.checkLocationPermission.bind(this);
        this.requestUserLocation = this.requestUserLocation.bind(this);
    }

    // Explicit "share my location" trigger from the panel button. Requests the
    // browser geolocation and, on success, stores the position so the list can
    // sort by distance. Records the polyfill grant like the call flow does.
    requestUserLocation() {
        if (!navigator.geolocation) return;
        navigator.geolocation.getCurrentPosition(
            (geoposition) => {
                localStorage.setItem('geolocation', 'granted');
                this.setState({
                    hasLocationPermission: true,
                    deniedLocationPermission: false,
                    userLocation: {
                        lat: geoposition.coords.latitude,
                        lng: geoposition.coords.longitude,
                    },
                });
                this.moveMap(geoposition.coords.latitude, geoposition.coords.longitude);
            },
            () => {
                localStorage.setItem('geolocation', 'denied');
                this.setState({ deniedLocationPermission: true });
            },
            { enableHighAccuracy: true, timeout: 15000, maximumAge: 300000 }
        );
    }

    componentDidMount() {
        this.setUdid();
        this.checkIframeMode();
        // this.checkServerHeartbeat();
        this.checkLocationPermission();

        // Add visibility change listener to pause/resume polling when tab is hidden
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
        if (document.hidden) {
            // Tab is hidden - pause polling to save battery and bandwidth
            console.log('[TrackerView] Tab hidden, pausing map data polling');
            if (this.getMapdataInterval) {
                clearTimeout(this.getMapdataInterval);
                this.getMapdataInterval = null;
            }
        } else {
            // Tab is visible again - resume polling
            console.log('[TrackerView] Tab visible, resuming map data polling');
            if (!this.getMapdataInterval && this.state.map !== null) {
                this.getMapdata();
            }
        }
    }

    setUdid() {
        const udid = window.localStorage.getItem('udid') || '';
        if (udid === '') {
            const nav = window.navigator;
            const screen = window.screen;
            let guid = nav.mimeTypes.length;
            guid += nav.userAgent.replace(/\D+/g, '');
            guid += nav.plugins.length;
            guid += screen.height || '';
            guid += screen.width || '';
            guid += screen.pixelDepth || '';

            localStorage.setItem('udid', guid);
        }
    }

    checkIframeMode() {
        const url = new URL(window.location.href);
        const c = url.searchParams.get("iframe");
        if (c === "no") {
            store.dispatch(setHideHeader(true));
        }
    }

    checkLocationPermission() {
        const that = this;
        navigator.permissions && navigator.permissions.query({name: 'geolocation'}).then(function(PermissionStatus) {
            const apply = (state) => {
                if('granted' === state) {
                    that.setState({
                        hasLocationPermission: true,
                        deniedLocationPermission: false,
                    });
                } else if('denied' === state) {
                    that.setState({
                        hasLocationPermission: false,
                        deniedLocationPermission: true,
                    });
                } else {
                    that.setState({
                        hasLocationPermission: false,
                        deniedLocationPermission: false,
                    });
                }
            };
            apply(PermissionStatus.state);
            // Re-apply when permission changes mid-session (e.g. granted via
            // the silent-call flow) so distances start flowing without reload.
            PermissionStatus.onchange = function() { apply(this.state); };
        });
        if (!navigator.permissions) {
            //This browser does not have the permissions API
            //Fallback to localstorage polyfill
            const geolocationState = localStorage.getItem('geolocation') || '';
            if('granted' === geolocationState) {
                that.setState({
                    hasLocationPermission: true,
                    deniedLocationPermission: false,
                });
            } else if('denied' === geolocationState) {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: true,
                });
            } else {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: false,
                });
            }
        }
    }

    getPOIdata() {
        const url = process.env.REACT_APP_ICECORP_API_HREF+"v1/pointofinterestmarkerdata?company_id="+process.env.REACT_APP_COMPANY_ID;
        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const pois = data.data;

            this.setState({
                pois: pois,
            });
        })
        .catch((error) => {
            console.warn('[TrackerView] Failed to fetch POI data:', error.message);
        });
    }

    getMapdata() {
        // No has_working_day filter: we want today's full roster, including
        // trucks that are only SCHEDULED (planned), so the list can show them.
        // Not-scheduled trucks are filtered out in the UI, and scheduled trucks
        // get no map marker until they have live GPS.
        const url = process.env.REACT_APP_ICECORP_API_HREF+"v1/icecreamvanmarkerdata?company_id="+process.env.REACT_APP_COMPANY_ID;
        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const karren = data.data || [];

            if (this.state.firstDraw && this.state.map !== null) {
                try {
                    const container = this.state.map.getContainer();
                    if (container && container.offsetParent !== null) {
                        this.state.map.panTo({
                            lat: process.env.REACT_APP_DEFAULT_LAT,
                            lng: process.env.REACT_APP_DEFAULT_LNG,
                        });
                    }
                } catch (error) {
                    console.warn('[TrackerView] Initial map pan failed:', error.message);
                }
            }

            karren.forEach(kar => {
                if ("kar"+kar.id === this.state.trackid) {
                    this.moveMap(kar.latitude, kar.longitude);
                }
            });

            const that = this;

            // Also honour the localStorage polyfill (browsers without the
            // Permissions API) so a grant during the session starts the flow.
            if (this.state.hasLocationPermission || localStorage.getItem('geolocation') === 'granted') {
                navigator.geolocation.getCurrentPosition(function(geoposition) {
                    const userLocation = {
                        lat: geoposition.coords.latitude,
                        lng: geoposition.coords.longitude
                    }

                    that.setState({
                        userLocation: userLocation,
                    });

                    if (that.state.trackid === "firstDrawUser") {
                        that.moveMap(geoposition.coords.latitude, geoposition.coords.longitude);
                        that.setState({
                            trackid: "user",
                        });
                    }
                });
            }

            // Success - reset error state and update timestamp
            this.setState({
                hasInternet: true,
                karren: karren,
                firstDraw: false,
                isLoading: false,
                loadError: null,
                lastSuccessfulFetch: Date.now(),
                consecutiveErrors: 0,
            });

            if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
            this.getMapdataInterval = setTimeout(this.getMapdata, 3000);
        })
        .catch((error) => {
            const newConsecutiveErrors = this.state.consecutiveErrors + 1;
            console.warn('[TrackerView] Failed to fetch map data:', error.message, `(attempt ${newConsecutiveErrors})`);

            // Show toast notification after 3 consecutive failures (but only once)
            if (newConsecutiveErrors === 3) {
                store.dispatch(setToast({
                    theme: 'warning',
                    message: 'Verbindingsprobleem - gegevens kunnen verouderd zijn',
                }));
            }

            // Keep existing data if we have it, just mark the error
            this.setState({
                loadError: error.message,
                consecutiveErrors: newConsecutiveErrors,
                isLoading: false,
                // Only set hasInternet to false if we have no data AND multiple failures
                hasInternet: this.state.karren.length > 0 || newConsecutiveErrors < 5,
            });

            if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
            // Use exponential backoff on errors (max 30 seconds)
            const backoffTime = Math.min(3000 * Math.pow(1.5, newConsecutiveErrors - 1), 30000);
            this.getMapdataInterval = setTimeout(this.getMapdata, backoffTime);
        });
    }

    static defaultProps = {
        center: {
            lat: process.env.REACT_APP_DEFAULT_LAT,
            lng: process.env.REACT_APP_DEFAULT_LNG,
        },
        zoom: 13
    };

    handleMapClick() {
        this.setState({
            trackid: "",
            lastFocusLatitude: 0,
            lastFocusLongitude: 0,
        });
    }

    handleClick(trackid, lat, long) {
        if (lat !== 0 || long !== 0) {
            this.moveMap(lat, long);
        }

        this.setState({
            trackid: trackid,
        });
    }

    moveMap(lat, long) {
        if (lat !== this.state.lastFocusLatitude || long !== this.state.lastFocusLongitude) {
            this.setState({
                lastFocusLatitude: lat,
                lastFocusLongitude: long,
            });
            // Check if map is properly initialized before panning
            // The _leaflet_pos error occurs when map container is not ready
            if (this.state.map !== null && !(lat === 0 && long === 0)) {
                try {
                    // Verify map container is still in DOM and initialized
                    const container = this.state.map.getContainer();
                    if (container && container.offsetParent !== null) {
                        this.state.map.panTo({
                            lat: parseFloat(lat),
                            lng: parseFloat(long)
                        });
                    }
                } catch (error) {
                    console.warn('[TrackerView] Map pan failed, map may not be ready:', error.message);
                }
            }
        }
    }

    setMap(map) {
        if (!this.state.map) {
            this.setState({
                map: map
            });

            this.getPOIdata();
            this.getMapdata();
        }
    }

    // Render stale data indicator (same condition as before; styling in CSS)
    renderStaleDataIndicator() {
        const { lastSuccessfulFetch, consecutiveErrors } = this.state;
        if (consecutiveErrors > 0 && lastSuccessfulFetch) {
            const secondsAgo = Math.floor((Date.now() - lastSuccessfulFetch) / 1000);
            if (secondsAgo > 30) {
                return (
                    <div className="stale-data-indicator">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" y1="8" x2="12" y2="12"/>
                            <line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        Laatste update: {secondsAgo}s geleden
                    </div>
                );
            }
        }
        return null;
    }

    // Render loading skeleton (cream, brand spinner; styling in CSS)
    renderLoadingSkeleton() {
        return (
            <div className="map-loading-skeleton">
                <div className="map-loading-spinner" />
                <p>Kaart laden...</p>
            </div>
        );
    }

    render() {
        if (this.state.hasInternet) {
            const POIMarkers = this.state.pois.map(poi => <POIMarker
                key = {"poi"+poi.id}
                trackid = {"poi"+poi.id}
                poi = {poi}
                lat={poi.latitude}
                lng={poi.longitude}
                Tooltip={"poi"+poi.id === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            />);

            // Markers only for trucks with real GPS data - scheduled/not-scheduled
            // trucks carry a planned position, not live GPS, so no marker yet.
            const TruckMarkers = this.state.karren.filter(hasLiveGps).map(kar => <TruckMarker
                key = {"kar"+kar.id}
                trackid = {"kar"+kar.id}
                kar = {kar}
                position={{lat: kar.latitude, lng: kar.longitude}}
                lat={kar.latitude}
                lng={kar.longitude}
                Tooltip={"kar"+kar.id === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            />);

            const UserMarkerIcon = (this.state.hasLocationPermission && this.state.userLocation !== null ? <UserMarker
                lat={this.state.userLocation.lat}
                lng={this.state.userLocation.lng}
                Latitude={this.state.userLocation.lat}
                Longitude={this.state.userLocation.lng}
                trackid = {"user"}
                Tooltip={"user" === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            /> : null);

            const userCenterButton = (this.state.hasLocationPermission && this.state.userLocation !== null ? <UserCenterButton
                Latitude={this.state.userLocation.lat}
                Longitude={this.state.userLocation.lng}
                trackid = {"user"}
                Tooltip={"user" === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            /> : null);

            const mapdivClass = (this.props.hideHeader ? "mapdivNoHeader" : "mapdiv");

            const contentClass = (this.props.hideHeader ? "content contentNoHeader" : "content");
            const button = (this.props.hideHeader ? <OpenAppButton handleMapClick={this.handleMapClick} /> : <CombinedButton handleMapClick={this.handleMapClick} />);
            const silentButton = (this.props.hideHeader ? null : <SilentCallButton handleMapClick={this.handleMapClick} />);

            // eslint-disable-next-line no-unused-vars
            const position = [51.505, -0.09];
            return (
                <main>
                    <div className={contentClass}>
                        <div className="tracker-layout">
                            {/* Important! Always set the container height explicitly */}
                            <div className={mapdivClass} style={{ position: 'relative' }}>
                                {this.state.isLoading && this.state.karren.length === 0 && this.renderLoadingSkeleton()}
                                {this.renderStaleDataIndicator()}
                                <StatusChip karren={this.state.karren} />
                                <MapContainer center={this.props.center} zoom={this.props.zoom} onMapReady={this.setMap}>
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                                        url={process.env.REACT_APP_API_HREF+"proxy.php?z={z}&x={x}&y={y}&r=cartovoyager"}
                                    />
                                    {UserMarkerIcon}
                                    {POIMarkers}
                                    {TruckMarkers}
                                    <CallMarker />
                                </MapContainer>
                                {userCenterButton}
                                {silentButton}
                            </div>
                            {!this.props.hideHeader && (
                                <NearbyPanel
                                    karren={this.state.karren}
                                    userLocation={this.state.userLocation}
                                    onSelectTruck={this.handleClick}
                                    onShareLocation={this.requestUserLocation}
                                />
                            )}
                            {/* FAB lives at tracker-layout level (above the bottom
                                sheet) so it never sits behind the truck list. */}
                            {button}
                        </div>
                    </div>
                </main>
            )
        } else {
            return (
                <main>
                    <div className="content">
                        <ErrorImage text="Je bent offline" subtext="Sommige onderdelen van de app werken mogelijk niet"/>
                    </div>
                </main>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        hideHeader: state.overlay.hideHeader || false,
    }
}

export default connect(mapStateToProps)(TrackerView);
